import React from "react";
import "./CSS/AIReasoningModal.css";

const AIReasoningModal = ({ showScores, rowData, onClose }) => {
  if (!rowData) return null;

  const { time, score, reasoning, childResponse, childTranscript } = rowData;

  return (
    <div className="reasoning-modal-overlay">
      <div className="reasoning-modal-content">
        <button className="close-modal-btn" onClick={onClose}>
          ✖
        </button>
        <h2>Analysis Details</h2>

        <div className="row-detail">
          <strong>Time:</strong> {time}
        </div>
        {showScores && (<div className="row-detail">
          <strong>Score:</strong> {score}
        </div>)}
        <div className="row-detail">
          <strong>Reasoning:</strong> {reasoning}
        </div>
        {childResponse && childResponse !== "-" && childResponse !== "—" && (
          <div className="row-detail">
            <strong>Child Response:</strong> {childResponse || "—"}
          </div>
        )}
        {childTranscript && childTranscript !== "-" && childTranscript !== "—" && (
          <div className="row-detail">
            <strong>Child Transcript:</strong> {childTranscript || "—"}
          </div>
        )}
      </div>
    </div>
  );
};

export default AIReasoningModal;
